import AutomaticPlannerScreenContainer from './LegacyAutomaticPlannerScreenContainer';

export default AutomaticPlannerScreenContainer;
